import React from "react";
import {
  DataGrid,
  FilterRow,
  Editing,
  Column,
  Paging,
  Pager,
  Lookup,
  FormItem,
} from "devextreme-react/data-grid";
import uiInfo from "../ui-info";
import PaginaToolbar from "../components/PaginaToolbar";
import { criarSituacaoCadastralDs } from "../DataSources";
import UserInfo from "../UserInfo";

export default class SituacoesCadastraisCpbsBox extends React.Component {
  constructor() {
    super();
    this.initNewRow = this.initNewRow.bind(this);
    this.tiposSituacoesDs = [
      { id: "1", descricao: "Ativo" },
      { id: "2", descricao: "Inativo" },
      { id: "3", descricao: "Baixado" },
      { id: "4", descricao: "Suspenso" },
    ];
  }

  render() {
    return (
      <div className={"content-block dx-card responsive-paddings"}>
        <PaginaToolbar titulo="SITUAÇÕES CADASTRAIS DE CPBS">
          <DataGrid
            dataSource={criarSituacaoCadastralDs()}
            showBorders={true}
            rowAlternationEnabled={true}
            remoteOperations={true}
            focusedRowEnabled={true}
            wordWrapEnabled={true}
            onInitNewRow={this.initNewRow}
          >
            <FilterRow visible={true} />
            <Editing
              mode={"row"}
              allowAdding={false}
              allowUpdating={true}
              allowDeleting={true}
            />
            <Column dataField={"id"} width={"150"} allowEditing={false} visible={false} />
            <Column dataField={"sequencial"} width={"150"} allowEditing={false}/>
            <Column
              dataField={"prefeituraId"}
              caption={"Prefeitura"}
              visible={false}
            >
              <FormItem visible={false}></FormItem>
            </Column>
            <Column dataField={"descricao"} caption={"Descrição"} />
            <Column dataField={"tipoId"} caption={"Tipo"}>
              <Lookup
                dataSource={this.tiposSituacoesDs}
                valueExpr={"id"}
                displayExpr={"descricao"}
              ></Lookup>
            </Column>
            <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
            <Pager
              showPageSizeSelector={true}
              allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
            />
          </DataGrid>
        </PaginaToolbar>
      </div>
    );
  }

  initNewRow(e) {
    e.data.prefeituraId = UserInfo.getPrefeitura();
  }
}
